export default __webpack_public_path__ + "static/media/Bold.bbe94519.woff";